@if (progress !== undefined) {
  <div [class]="'loader' + getProgressClass()"
    >
    <div class="overlay"></div>
    <div class="content">
      @for (child of templates; track child) {
        <ng-container *ngTemplateOutlet="child"></ng-container>
      }
    </div>
    <div class="timer fill">
      <div class="half-circle-left-mask">
        <div class="half-circle-left"></div>
      </div>
      <div class="half-circle-right-mask">
        <div class="half-circle-right"></div>
      </div>
    </div>
  </div>
}
@for (child of templates; track child) {
  <ng-container *ngTemplateOutlet="child"></ng-container>
}